/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './createJoinLink.defs'
export { main as default } from './createJoinLink.defs'
